import { Card, Text } from '@change/ds-core-ui';

import { useTracking } from '../../../../hooks/useTracking';
import { AvatarAndBadge } from '../../../../shared/components/AvatarAndBadge';
import { DecisionMakerResponse } from '../../../../shared/components/DecisionMakerResponse';
import { Name } from '../../../../shared/components/Name';
import { ResponseBadge } from '../../../../shared/components/ResponseBadge';
import { SignersTooltip } from '../../../../shared/components/SignersTooltip';
import type { NormalizedDecisionMaker } from '../../../../shared/types';

export const DecisionMakerCardMobile: React.FC<{ dm: NormalizedDecisionMaker }> = ({
	dm: {
		displayName,
		id,
		title,
		photoUrl,
		publiclyVisible,
		slug,
		response,
		constituentCount,
		constituentCountLocalized,
		isFormer,
		type,
	},
}) => {
	const { trackDMMoreInfoClick } = useTracking();
	return (
		<Card className="bg-white p-6 shadow-md lg:hidden">
			<div className="flex gap-4">
				<div>
					<AvatarAndBadge displayName={displayName} photoUrl={photoUrl} showDMIcon={type === 'POLITICIAN'} />
				</div>

				<div className="w-full">
					<div className="flex w-full flex-col flex-wrap xl:flex-row">
						<div className="w-full">
							<div className="mr-1 w-full">
								<div className="flex items-center gap-[6px]">
									<Name displayName={displayName} id={id} publiclyVisible={publiclyVisible} slug={slug} />
									{constituentCount > 0 && (
										<div className="flex items-center">
											<SignersTooltip
												constituentCount={constituentCount}
												constituentCountLocalized={constituentCountLocalized}
												isFormer={isFormer}
												onTooltipClick={() => trackDMMoreInfoClick(id)}
											/>
										</div>
									)}
								</div>
							</div>

							<Text variant="body" className="mb-2 block">
								{title}
							</Text>
						</div>

						<div className="mb-2">
							<ResponseBadge response={response} />
						</div>
					</div>

					{response && <DecisionMakerResponse response={response} />}
				</div>
			</div>
		</Card>
	);
};
